import { IsEnum, IsNotEmpty, IsString } from 'class-validator';
import { OpticOddsFixtureStatus } from '../../enums/optic-odds-fixture-status.enum';

export class UpdateMatchStatusDto {
	@IsString()
	@IsNotEmpty()
	ext_api_id: string;

	@IsEnum(OpticOddsFixtureStatus)
	status: OpticOddsFixtureStatus;
}

export interface UpdateMatchStatusResponse {
	success: boolean;
}
